export const CUSTOM_IMAGE_MATERIAL_SLOT_NAME = "iventis_custom_image";
export const CUSTOM_COLOUR_MATERIAL_SLOT_NAME = "iventis_custom_colour";
